export default {
	defaultTitle: "lpg.space",
	defaultDescription: "Personal website of Lucien Greathouse",
};